// ─────────────────────────────────────────────────────────────────────────────
// Pure YoY helpers for Growth Analysis. Kept out of the page component so the
// year-over-year merge and growth-rate maths are unit-testable.
// ─────────────────────────────────────────────────────────────────────────────

// Growth rate of a vs a baseline b, as a whole-number percentage.
// null when there is no baseline to grow from: a rate is undefined against zero,
// and returning 0 would render as "flat", which is a different — and false —
// claim. Callers render null as "—". Matches mergeYoY's no-baseline semantics.
export function growthPct(a, b) {
  return b > 0 ? Math.round(((a - b) / b) * 100) : null;
}

// Merge two arrays (previous / current year) keyed by keyField, reading the value
// from valField. Returns one row per key: { key, prev, curr, g } where g is the
// YoY growth % (null when there is no prior-year baseline). Not sorted — callers
// sort/slice as needed.
export function mergeYoY(prevArr, currArr, keyField, valField) {
  const m = {};
  (prevArr || []).forEach(r => {
    m[r[keyField]] = { key: r[keyField], prev: r[valField] || 0, curr: 0 };
  });
  (currArr || []).forEach(r => {
    if (!m[r[keyField]]) m[r[keyField]] = { key: r[keyField], prev: 0, curr: 0 };
    m[r[keyField]].curr = r[valField] || 0;
  });
  return Object.values(m).map(x => ({
    ...x,
    g: x.prev > 0 ? Math.round(((x.curr - x.prev) / x.prev) * 100) : null,
  }));
}
